import { url } from "./url_config";

export async function getDeviceDashboard(id, token) {
    try {
        const response = await fetch(`${url}devices?id=${id}&getConsumption=true`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(!response.ok) {
            return { error: true, status_code: response.status };
        }

        const data = await response.json();

        if (data.error === true) {
            return { error: true, message: data.message || "API error" };
        }

        return { error: false, data: data.body };

    } catch (e) {
        console.error("getDeviceDashboard error:", e);
        return null;
    }
}